import { render, staticRenderFns } from "./CenterCncc.vue?vue&type=template&id=68141df2&"
import script from "./CenterCncc.vue?vue&type=script&lang=js&"
export * from "./CenterCncc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports